module.exports = __webpack_public_path__ + "img/jwgl-kbbd-lsjq.2d130dff.png";